export default __webpack_public_path__ + "static/media/planta_82.9c57975c.png";